import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'button-group\'>\n  {{yield\n    (component \'ui/button\' isButtonGroup=true)\n    (component \'ui/button/icon\' isButtonGroup=true)\n  }}\n</div>")